var userClaims = "";

class OktaUserDetails {
    constructor() {
        userClaims = JSON.parse(localStorage.getItem("userClaims"));
    }

    getUserName() {
        return userClaims.userClaims.FirstName + " " + userClaims.userClaims.LastName;
    }
    getUserId() {
        if (userClaims) {
            return userClaims.userClaims.Email;
        }
        else {
            return "";
        }
    }
    getUserEmailId() {
       return userClaims.userClaims.Email;
    }
    getAccessToken() {
        return "12345";
    }
    getUserRoles() {
        return userClaims.userClaims.UserPrivileges;
    }
}

export default OktaUserDetails;